import { html } from "lit";
import { translate, use } from "lit-translate";
import { BasicApp } from "../../layout/basicApp";
import Uikit from "uikit";

class SettingsTab extends BasicApp {
  constructor() {
    super()
    console.log('x', localStorage.getItem("darkModeOn"), localStorage.getItem("ds"))

    const isModeSet = localStorage.getItem("darkModeOn")
    const userDefaultDarkModeOn = window.matchMedia('(prefers-color-scheme: dark)').matches

    this.currentLang = localStorage.getItem("lang") ? localStorage.getItem("lang") : "en"
    this.isDarkMode = (isModeSet) ? (localStorage.getItem("darkModeOn") === "true") : userDefaultDarkModeOn

    localStorage.setItem("darkModeOn", this.isDarkMode)

    this.updateDarkModeState(this.isDarkMode)
  }

  createRenderRoot() {
    return this;
  }

  changeLanguage(langToUpdate) {
    use(langToUpdate).then(() => {
      this.currentLang = langToUpdate
      var $dropdown = Uikit.dropdown('.uk-dropdown', {
        delayHide: 0
      });
      $dropdown.hide();
      localStorage.setItem("lang", langToUpdate)
      this.requestUpdate()
    })
  }

  changePageColorsMode() {
    this.isDarkMode = !this.isDarkMode
    localStorage.setItem("darkModeOn", this.isDarkMode)

    this.updateDarkModeState(this.isDarkMode)
  }

  render() {
    return html`
        <div class="outer settings-page">
            <h1 class="page-ttl">${translate("settings.title")}</h1>
            <hr>
            <div class="settings-option">
                <p class="settings-option__label">${translate("settings.toggleDarkMode")}</p>
                <input class="checkbox" type="checkbox" @change="${this.changePageColorsMode}"
                       ?checked="${this.isDarkMode}"/>
            </div>
            <hr>
            <div class="settings-option">
                <p class="settings-option__label">${translate("settings.changeLanguage")}</p>
                <div>
                    <button class="uk-button uk-button-default" type="button">${this.currentLang}</button>
                    <div uk-dropdown="mode: click; hide: true">
                        <ul class="uk-nav uk-dropdown-nav">
                            <li class="${(this.currentLang === 'en') ? 'uk-active' : ''}"
                                @click="${() => this.changeLanguage('en')}">${translate("settings.language.en")}
                            </li>
                            <li class="uk-nav-divider"></li>
                            <li class="${(this.currentLang === 'pl') ? 'uk-active' : ''}"
                                @click="${() => this.changeLanguage('pl')}">${translate("settings.language.pl")}
                            </li>
                            <li class="uk-nav-divider"></li>
                            <li class="${(this.currentLang === 'es') ? 'uk-active' : ''}"
                                @click="${() => this.changeLanguage('es')}">${translate("settings.language.es")}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <hr>
        </div>`;
  }

  updateDarkModeState(newState) {
    const myevent = new CustomEvent('my-event', {
      bubbles: true,
      composed: true,
      detail: {
        value: newState
      }
    })
    this.dispatchEvent(
      myevent
    );
  }
}

customElements.define('settings-tab', SettingsTab);




